import styled from 'styled-components';

export const BulletPoint = styled.span<{ isOnline: boolean }>`
  display: inline-block;
  height: 13px;
  width: 13px;
  border-radius: 50%;
  background-color: ${(props) => (props.isOnline ? 'green' : 'gray')};
`;
